import { div } from '@mui/system'
import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilled, ButtonFilledAutoWidth } from '../../../components/button'
import { TextAreaInput1, TextInput } from '../../../components/input'
import { CreateDepartmentService, UpdateDepartmentService } from '../../../services/DepartmentServices'
import { useNavigate, useLocation } from 'react-router-dom'
import { MobileBackOption } from '../../../components/appbars/mobile/DashboardMobile'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { message } from 'antd'
import { CreateFollowupService, UpdateFollowupService } from '../../../services/admin/FollowupServices'
import { CreateStudentSubjectService, UpdateStudentSubjectService } from '../../../services/admin/StudentSubjectServices'
import { CreateStudentBoardService, UpdateStudentBoardService } from '../../../services/admin/StudentBoardServices'

function StudentBoardCE() {
 
  const [data,setdata] = useState({name:'',label:'',match_string:''});  
  const [error,seterror] = useState({name:'',label:'',match_string:''}); 
  
  const {state} = useLocation();
  const navigate = useNavigate();


  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      setdata({...data,...state})
    }

  },[state])

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    if(!data.name){
        seterror({...error,name:'Name field is required *'})
    }else if(!data.label){
        seterror({...error,label:'Label field is required *'})
    }else if(!data.match_string){
        seterror({...error,match_string:'Match String field is required *'})
    }else{
        if(state?._id === undefined || state?._id === null){
        const response = await CreateStudentBoardService(data)
        if (response.status === 201) {
          resetform()
          toast.success('Student Board Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,days:response?.data?.errors?.days})
        } 
      }else{
        let send_data = {...data}
        const response = await UpdateStudentBoardService(send_data,state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('Student Board Updated Successfully')
        }   
        if(response.status === 422){
           seterror({...error,days:response?.data?.errors?.days})
        } 
      }
  }
  }


  function resetform(){
    setdata({name:'',label:'',match_string:''})
    seterror({name:'',label:'',match_string:''})
  }
  

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
    <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack /> 

        <h6 className='font-[700]'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'} Student Board</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Student Board</b> for your clients segregate followup.</h6>
     

        <TextInput 
            label={'Name'}  
            variant="standard"
            name="name"
            type="text"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder="Enter your name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

          <TextInput 
            label={'Label'}  
            variant="standard"
            name="label"
            type="text"
            error={error.label}
            value={data.label}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>  

             <TextAreaInput1 
            label={'Match String'}  
            variant="standard"
            name="match_string"
            type="text"
            error={error.match_string}
            value={data.match_string}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

        <div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE STUDENT BOARD" : "ADD STUDENT BOARD"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default StudentBoardCE